<template>
  <BittsContainer class="seat-type-card">
    <div class="flex flex-col gap-4">
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
    </div>
    <div class="flex items-center gap-8">
      <BittsSvg svg="salesforceIcon" class="w-16 h-16" />
      <i>Includes Crossbeam Copilot for Salesforce</i>
    </div>
    <div class="flex items-center gap-8">
      <FontAwesomeIcon
        :icon="['far', 'circle-check']"
        class="text-success-text"
      />
      <i>Includes 1 seat as part of Connector Plan</i>
    </div>
    <BittsStepper
      v-model="numSeats"
      units="seats"
      :min="minSeats"
      @update:model-value="onUpdateSeatCount"
    />
    <slot name="extra" />
  </BittsContainer>
</template>

<script setup lang="ts">
import { BittsContainer, BittsStepper, BittsSvg } from '@crossbeam/bitts';

import { ref, watch } from 'vue';

const {
  title,
  description,
  initialNumSeats = 1,
  minSeats = 1,
  type,
} = defineProps<{
  title: string;
  description: string;
  type: string;
  initialNumSeats?: number;
  minSeats?: number;
}>();

const emit =
  defineEmits<(e: 'update:seat-count', count: number, type: string) => void>();

const numSeats = ref(initialNumSeats);

watch(
  () => minSeats,
  () => {
    const newSeatCount = Math.max(numSeats.value, minSeats);
    if (newSeatCount !== numSeats.value) onUpdateSeatCount(newSeatCount);
  },
);

function onUpdateSeatCount(newCount: number) {
  numSeats.value = newCount;
  emit('update:seat-count', newCount, type);
}
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
.seat-type-card {
  @apply flex flex-col gap-16;
}
:deep(.bitts-container) {
  @apply rounded-bts-sm border-neutral-border p-24;
}
h2 {
  @apply font-bold text-neutral-text-strong text-m;
}
p {
  @apply text-neutral-text;
}
i {
  @apply text-neutral-text-weak;
}
</style>
